import { useMutation } from '@tanstack/react-query';
import { ChatWithBotRequest } from '@/types/request/ChatWithBotRequest';
import { BackendSuccessResponse } from '@/types/response/Api/BackendSuccessResponse';
import { BackendErrorResponse } from '@/types/response/Api/BackendErrorResponse';
import { ChatMessage } from '@/models/ChatMessage';
import BackendClient from '@/api/backendClient.ts';
import { transformBackendErrors } from '@/utils/transformBackendErrors.ts';

const useChatWithBot = () => {
  const mutationFn = async (request: ChatWithBotRequest) => {
    return chatWithBot(request);
  };

  return useMutation({
    mutationFn,
  });
};

export default useChatWithBot;

async function chatWithBot(request: ChatWithBotRequest): Promise<ChatMessage[]> {
  try {
    const response = await BackendClient.post<BackendSuccessResponse<ChatMessage[]>>('/api/chat/message', request);

    return response.data.data;
  } catch (error: any) {
    if (error.response && error.response.data) {
      const errorResponse = error.response.data as BackendErrorResponse;

      throw new Error(transformBackendErrors(errorResponse).join(', '));
    }

    throw new Error(error.message ?? 'An error occurred while sending message to chat.');
  }
}
